// Discrepancy-popup sections + the dispatch-deadline banner, for the Fulfill order modals.
import { daysUntil } from '@/lib/utils';

const DEADLINE_DAYS_THRESHOLD = 7;

// An outgoing-shipment candidate row — Select outgoing shipment modal.
export const buildOutgoingShipmentDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_STATUS'), value: row.status, type: 'status', tone: row.statusTone },
        { label: t('FIELD_SENT_BY'), value: row.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: row.shippingTo },
        { label: t('FIELD_RECEIVED_AT'), value: row.facilityName },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: row.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY_IN_UNIT', { unit: unit.unit ?? '' }),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        { label: t('FIELD_ALLOCATED_QUANTITY'), value: unit.allocatedQuantity },
        { label: t('ORDERS_COL_REMAINING_TO_ALLOCATE'), value: unit.remainingToAllocateQuantity },
      ],
    },
  ];
};

// An inbound candidate row — Select inbound modal.
export const buildInboundDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_DECLARATION_NO'), value: row.declarationNo },
        { label: t('FIELD_RAW_MATERIAL_TYPE'), value: row.rawMaterialType },
        { label: t('FIELD_COUNTRY_OF_ORIGIN'), value: row.countryOfOrigin },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: row.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY_IN_UNIT', { unit: unit.unit ?? '' }),
      fields: [
        { label: t('FIELD_AVAILABLE_QUANTITY'), value: unit.balanceQuantity },
        { label: t('FIELD_GHG_EMISSIONS'), value: row.ghgEmissions },
        { label: t('FIELD_GHG_EMISSION_SAVINGS'), value: row.ghgEmissionSavings },
      ],
    },
  ];
};

/**
 * The dispatch-deadline banner — only once the row's own dispatch date is 7 days out
 * or closer AND it still carries a pending amount; null hides the banner entirely.
 *
 * @param dateOfDispatch  the row's raw (unformatted) dispatch date
 * @param pendingQuantity the row's raw (unformatted) pending amount, in `unit`
 */
export const buildDeadlineWarning = (t, { dateOfDispatch, pendingQuantity, unit }) => {
  const days = daysUntil(dateOfDispatch);
  if (days == null || days > DEADLINE_DAYS_THRESHOLD || !pendingQuantity) return null;
  return t('ORDERS_FULFILL_DEADLINE_WARNING', {
    days,
    pendingQty: `${pendingQuantity} ${unit ?? ''}`.trim(),
  });
};
